import React, { useState, useEffect } from 'react'
import { toast } from '@CommonComponents/toast'
import PropTypes from 'prop-types'
import { client } from '@Utils'

export const App = ({ userId }) => {
  const [roles, setRoles] = useState([])

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        let resp = await client.get(
          `/account/support_dashboard.get_user_roles/-/${userId}/`
        )
        setRoles(resp.data.roles)
      } catch (err) {
        if (err.response) {
          toast.error(`Error Status: ${err.response.status} - ${err.response.data?.error}`)
        } else {
          toast.error(`Network error: ${err.message}`)
        }
      }
    }
    fetchRoles()
  }, [userId])

  const assignedRoles = roles.filter(role => role.has_role)

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <tbody>
        {assignedRoles.map(role => (
          <tr key={role.name} style={{ borderBottom: '1px solid #ddd' }}>
            <td style={{ padding: '4px 8px', border: '1px solid #ddd' }}>{role.ui_name}</td>
            <td style={{ padding: '4px 8px', border: '1px solid #ddd', textAlign: 'center' }}>
              <div className="icon icon_checkmark icon_color_green"></div>
            </td>
          </tr>
        ))}
        {assignedRoles.length === 0 && (
          <tr>
            <td colSpan={2} style={{ padding: '4px 8px', color: '#888', fontStyle: 'italic' }}>
              No roles assigned
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

App.propTypes = {
  userId: PropTypes.string,
}
